import { ReactComponent as LoopiSvg } from '../../assets/LoopiLogo.svg';

export function LoopiLogo({ color = '#E23E83', style, ...props }) {
  return <LoopiSvg {...props} style={{ ...style, color }} />;
}
